import MaterialAvatar, { AvatarProps } from '@mui/material/Avatar';

interface CustomAvatarProps extends AvatarProps {
    name?: string;
}

export function Avatar({ name, src, ...props }: CustomAvatarProps) {
    function stringAvatar(name: string) {
        const parts = name.trim().split(' ');
        const first = parts[0]?.[0] ?? '';
        const second = parts[1]?.[0] ?? '';
        return { children: `${first}${second}` };
    }

    return (
        <MaterialAvatar
            data-testid={'Avatar-container'}
            {...(src ? { src } : name ? stringAvatar(name) : {})}
            {...props}
        ></MaterialAvatar>
    );
}

export default Avatar;
